// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"714":"ed91e5ff","787":"db4952f7","870":"8829e946"}[chunkId] + ".chunk.js";
};